
$(document).ready(function() {
  function customvariant() {
    $("[select-variant]").change(function(){
      var data = $(this);
      var total = $(data).parents('.products').find('[select-variant]').length;
      var variantTitle = '';
      $(data).parents('.products').find('.product-form-submit').prop('disabled', true);
    $(this).parents('.products').find('[select-variant]').each(function(index) {
      variantTitle += $(this).val();
        if (index === total - 1) {
            // this is the last one
        } else {
          variantTitle += " / ";
        }
    });
      jQuery.getJSON(window.Shopify.routes.root + 'products/'+ $(this).attr('product-handle')+'.js', function(product) {
        $.each(product.variants, function( index, value ) {
          if(variantTitle == value.title){
            if(value.id){
              if(value.compare_at_price != null){
  
                // Extract prices and convert to floats
                var compareAtPrice = parseFloat(value.compare_at_price) / 100;
                var price = parseFloat(value.price) / 100;
               // Calculate the savings
                var savings = compareAtPrice - price;
               
                $(data).parents('.products').find('.grid-product__price .grid-product__price--current .grid-product__price--from').html(`<span>from </span> ₹ ${parseFloat(value.price/100)}`);
                $(data).parents('.products').find('.grid-product__price .grid-product__price--original span').text("₹ "+parseFloat(value.compare_at_price/100));
                
                // Update the text with the calculated savings
                $(data).parents('.products').find('.grid-product__price .grid-product__price--savings').text("Save ₹ " + savings);
              } else {
                $(data).parents('.products').find('.grid-product__price .grid-product__price--current .grid-product__price--from').text("₹ "+parseFloat(value.price/100));
              }
              $(data).parents('.products').find('[name="id"]').val(value.id);
            }
            
            if(value.available){
              $(data).parents('.products').find('.product-form-submit span').html("Add to cart");
              $(data).parents('.products').find('.product-form-submit').prop('disabled', false);
            } else {
              $(data).parents('.products').find('.product-form-submit span').html("Sold out");
              $(data).parents('.products').find('.product-form-submit').prop('disabled', true);
            }
          }
        });
      });
    }); 

    // Select all form elements on the page
  var forms = document.querySelectorAll('.product-form form');
  // Iterate over each form element
  forms.forEach(function(formElement) {
    formElement.addEventListener('submit', function(event) {
      event.preventDefault();
      let submitButton = formElement.querySelector('.product-form-submit');
      submitButton.classList.add('btn--loading');
      let getMasterInput = event.target.querySelector('input[name="id"]');
      let masterVariantId = getMasterInput?.value;
       console.log(masterVariantId, 'masterVariantId');
  if(masterVariantId){
      let formData = {
         'items': [{
          'id': masterVariantId,
          'quantity': 1
          }]
        };
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
         
        .then(response => {
          return response.json();
        }).then(data => {
          var product = data;
          
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: product,
                addToCartBtn: null
              }
          }));
          submitButton.classList.remove('btn--loading');
        })
        .catch((error) => {
          console.error('Error:', error);
          submitButton.classList.remove('btn--loading');
        });
  }

    });
  });
  }

  customvariant();



  document.addEventListener('recommendations:loaded', function() {
    customvariant();
  });
  
});

// AddtoCart Ajax End 